import Cookies from 'js-cookie'
import qs from 'qs'
import BigNumber from 'bignumber.js'
export default {
  data() {
    /* eslint-disable */
    return {
      // 设置属性
      mixinViewModuleOptions: {
        activatedIsNeed: true, // 此页面是否在激活（进入）时，调用查询数据列表接口？
        getDataListURL: '', // 数据列表接口，API地址
        getDataListIsPage: false, // 数据列表接口，是否需要分页？
        deleteURL: '', // 删除接口，API地址
        deleteIsBatch: false, // 删除接口，是否需要批量？
        deleteIsBatchKey: 'id', // 删除接口，批量状态下由那个key进行标记操作？比如：pid，uid...
        exportURL: '', // 导出接口，API地址
        summariesColumn:[]
      },
      // 默认属性
      dataForm: {}, // 查询条件
      dataList: [], // 数据列表
      order: '', // 排序，asc／desc
      orderField: '', // 排序，字段
      page: 1, // 当前页码
      limit: 20, // 每页数
      total: 0, // 总条数
      dataListLoading: false, // 数据列表，loading状态
      dataListSelections: [], // 数据列表，多选项
      addOrUpdateVisible: false, // 新增／更新，弹窗visible状态
    }
    /* eslint-enable */
  },
  activated() {
    if (this.mixinViewModuleOptions.activatedIsNeed) {
      this.getDataList()
    }
  },
  methods: {
    getSummaries (param) {
      if(!this.mixinViewModuleOptions.summariesColumn||this.mixinViewModuleOptions.summariesColumn.length===0){
        return
      }
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
          return
        }
        if(this.mixinViewModuleOptions.summariesColumn.indexOf(column.property)===-1){
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            let value = Number(curr)
            if (!isNaN(value)) {
              return new BigNumber(prev).plus(curr).toFixed(2)
            } else {
              return prev
            }
          }, 0)
        }
      })
      return sums
    },
    reload(){
      this.page=1
      this.getDataList()
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true
      this.$http
        .get(this.mixinViewModuleOptions.getDataListURL, {
          params: {
            order: this.order,
            orderField: this.orderField,
            page: this.mixinViewModuleOptions.getDataListIsPage
              ? this.page
              : null,
            limit: this.mixinViewModuleOptions.getDataListIsPage
              ? this.limit
              : null,
            ...this.dataForm,
          },
        })
        .then(({ data: res }) => {
          this.dataListLoading = false
          if (res.code !== 0) {
            this.dataList = []
            this.total = 0
            return this.$message.error(res.msg)
          }
          let dataList = this.mixinViewModuleOptions.getDataListIsPage
            ? res.data.list
            : res.data
          if (dataList === null) {
            dataList = []
          }
          if (this.beforeTableBinding) {
            this.beforeTableBinding(dataList)
          }

          this.dataList = dataList
          this.total = this.mixinViewModuleOptions.getDataListIsPage
            ? res.data.total
            : 0
          this.$nextTick(() => {
            if (this.afterTableBinding) {
              this.afterTableBinding(dataList)
            }
          })
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    // 多选
    dataListSelectionChangeHandle(val) {
      this.dataListSelections = val
    },
    // 排序
    dataListSortChangeHandle(data) {
      if (!data.order || !data.prop) {
        this.order = ''
        this.orderField = ''
        return false
      }
      this.order = data.order.replace(/ending$/, '')
      this.orderField = data.prop.replace(/([A-Z])/g, '_$1').toLowerCase()
      this.getDataList()
    },
    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.page = 1
      this.limit = val
      this.getDataList()
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.page = val
      this.getDataList()
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        if (id) {
          this.$refs.addOrUpdate.id = id
          this.$refs.addOrUpdate.dataForm.id = id
        } else {
          this.$refs.addOrUpdate.id = ''
          this.$refs.addOrUpdate.dataForm.id = ''
        }
        this.$refs.addOrUpdate.init()
      })
    },
    // 删除
    deleteHandle(id) {
      if (
        this.mixinViewModuleOptions.deleteIsBatch &&
        !id &&
        this.dataListSelections.length <= 0
      ) {
        return this.$message({
          message: this.$t('prompt.deleteBatch'),
          type: 'warning',
          duration: 500,
        })
      }
      this.$confirm(
        this.$t('prompt.info', { handle: this.$t('delete') }),
        this.$t('prompt.title'),
        {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
        }
      )
        .then(() => {
          let idArr = id
            ? [id]
            : this.dataListSelections.map(
              (item) => item[this.mixinViewModuleOptions.deleteIsBatchKey]
            )
          this.$http
            .delete(
              `${this.mixinViewModuleOptions.deleteURL}${this.mixinViewModuleOptions.deleteIsBatch ? '' : '/' + id
              }`,
              this.mixinViewModuleOptions.deleteIsBatch
                ? {
                  data: idArr,
                }
                : {}
            )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg)
              }
              if (this.afterDelHandle) {
                this.afterDelHandle(idArr)
              }
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.getDataList()
                },
              })
            })
            .catch(() => { })
        })
        .catch(() => { })
    },
    // 导出
    exportHandle() {
      var params = qs.stringify({
        token: Cookies.get('token'),
        ...this.dataForm,
      })
      window.location.href = `${window.SITE_CONFIG['apiURL']}${this.mixinViewModuleOptions.exportURL}?${params}`
    },
  },
}
